import {DataGrid} from '@mui/x-data-grid';


import {useState, useEffect, createContext} from "react";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import * as React from "react";

import {get99ContractDataPoints} from "../../ContractDataPoint/ContractDataPointClient";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";


export const CDPcontext = createContext();

function WorkDashboardCDPGrid(props) {
    const [drilldownCDP, setDrilldownCDP] = useState([]);
    let [filterContractSectionId, setFilterContractSectionId] = useState(0)
    const [collapsed, setCollapsed] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [showDrawer, setShowDrawer] = useState(false);
    const [gridFilter, setGridFilter] = useState(103);
    const [allCDPs, setAllCDPs] = useState([]);
    const [filteredCDP, setFilteredCDP] = useState([]);

    const [selectedCDP, setSelectedCDP] = useState([]);

    // var showCDPDrawerTrue = 'true';
    //https://stackoverflow.com/questions/32414308/updating-state-on-props-change-in-react-form (answer 43)
    const [selectedSection, setSelectedSection] = useState(props.selectedSection)
    //
    useEffect(() => {
        if (props.selectedSection !== selectedSection) {
            setSelectedSection(props.selectedSection);
            console.log("this is my CDP selectedSection");
            console.log(props.selectedSection)
            console.log("this is my filtered filters data");
            console.log(allCDPs.filter(allCDPs => allCDPs.contractSectionId == selectedSection));
            // setFilteredCDP(allCDPs.filter(allCDPs => allCDPs.contractSectionId ==  props.selectedSection))
            // setFilteredCDP(allCDPs.filter(allCDPs => allCDPs.contractSection.id ==  props.selectedSection))
            setFilteredCDP(allCDPs.filter(allCDPs => allCDPs.contractSectionId ==  props.selectedSection))
            // const thisFuckingCDP = allCDPs.filter(allCDP => allCDP.index(1) === '1');
            // console.log("this is my fucking single CDP");
            // console.log(thisFuckingCDP);
            // CDPcontext.Provider.value={selectedSection};
        }
    }, [props.selectedSection]);



    const renderContractDataPoints2 = drilldownCDP => {
        if (drilldownCDP.length <= 0) {
            return "No Data";
        }}


    const handleExplore = (selectedCDP, rowElement, rowFull) => {
        setSelectedCDP(selectedCDP);
        props.passSelectedCDP(selectedCDP);
        console.log("This is what was received");
        console.log(selectedCDP);
        console.log("This is my context CDP");
        console.log(createContext(CDPcontext));
        props.passShowCDPVDrawer(true);
        console.log("props generated by cdp grid");
    }


    const columns = fetchDrilldownCDP => [
        {
            field: "cDPExplore",
            headerName: '',
            width: 30,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            renderCell: (filteredCDP) => {
                return (
                    <IconButton
                        size="small"
                        variant="contained"
                        color="primary"
                    >
                        <CDPcontext.Provider value={selectedCDP}>
                            <MoreVertIcon onClick= {() => handleExplore(filteredCDP.row.id,  filteredCDP.row)}/>
                        </CDPcontext.Provider>
                    </IconButton>
                );
            }
        },
        {
            field: 'id',
            headerName: 'ID',
            description: '',
            sortable: true,
            // editable: true,
            width: 60,
            hide: true,
        },
        // {
        //     field: 'contractSectionId',
        //     headerName: 'cs',
        //     description: '',
        //     sortable: true,
        //     // editable: true,
        //     width: 30,
        //     hide: true,
        // },
        {
            field: 'contractSectionId',
            headerName: 'cs',
            renderCell: (filteredCDP) => {
                return <div className="rowitem">{filteredCDP.row.contractSectionId.id}</div>;},
            description: '',
            sortable: true,
            // editable: true,
            width: 30,
            hide: true,
        },
        {
            field: 'ordinalNumber',
            headerName: '#',
            description: '',
            sortable: false,
            // editable: true,
            width: 30,
        },
        // {
        //     field: 'dataPointId',
        //     headerName: 'Data Point',
        //     description: '',
        //     sortable: false,
        //     width: 90,
        // },
        {
            field: 'dataPointName',
            headerName: 'Name',
            //https://stackoverflow.com/questions/65592494/material-ui-datagrid-with-nested-data ANSWER 6 on page
            // renderCell: (filteredCDP) => {
            //     return <div className="rowitem">{filteredCDP.row.dataPoint.name}</div>;},
            description: '',
            sortable: false,
            width: 250,
        },
        {
            field: 'contractLevel',
            headerName: 'Level',
            description: '',
            sortable: false,
            width: 200,
        },
    ]


// function setFilters() {let setFilterContractSectionId = props.selectedSection};

    const fetchDrilldownCDP = () =>
        get99ContractDataPoints()

            .then(data => {
                console.log(data);
                setDrilldownCDP(data);
                setAllCDPs(data);
            })
    useEffect(() => {
        console.log("This is working so far...");
        fetchDrilldownCDP();
    }, []);

    function onChange(pagination, filters, sorter, extra) {
        console.log('params', pagination, filters, sorter, extra);
    }






    return (
        <div style={{ height: '40%' , width: '100%' }}>

            {/*{'false' && <CDPVDrawer passSelectedCDP = {selectedCDP}*/}
            {/*passShowCDPDrawer = {showCDPDrawerTrue}/>}*/}

                <Box
                    //     sx={{ fontWeight: 'bold',
                    //         fontSize: 20
                    //         // fontSize: 'h1.fontSize'
                    // }}
                    // sx={{mr: 0, mb: 0, verticalAlign: 'bottom'}}
                >
                    {/*<h3 >Contract Data Points*/}
                    {/*    /!*{props.selectedSection} {selectedSection} *!/*/}
                    {/*</h3>*/}
                    <Typography sx={{ fontWeight: 'bold'
                        // htmlFontSize: 48
                        // fontsize: 48
                    }} >Display Fields</Typography>
                </Box>
            <DataGrid
                style={{ height: '100% - 20px' , width: '100%' }}
                aria-label={"ContractDataPoints2"}
                rows={filteredCDP}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={columns(fetchDrilldownCDP)}
                density={"compact"}
                pageSize={50}
                rowsPerPageOptions={[50]}
                // filterModel={GridFilterModel}
                // Options={{
                //     filter: {
                //         filterModel: {
                //             items: [{ columnField: 'contractSectionId', operatorValue: 'equals', value: '' }],
                //         },
                //     },
                // }}
            />

        </div>
    );


}
export default WorkDashboardCDPGrid;



